import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

export const useBreakpoints = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mobileQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const tabletQuery = window.matchMedia(
      `(min-width: ${MOBILE_BREAKPOINT}px) and (max-width: ${TABLET_BREAKPOINT - 1}px)`
    );
    const desktopQuery = window.matchMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);

    const updateBreakpoints = () => {
      setIsMobile(mobileQuery.matches);
      setIsTablet(tabletQuery.matches);
      setIsDesktop(desktopQuery.matches);
    };

    mobileQuery.addEventListener('change', updateBreakpoints);
    tabletQuery.addEventListener('change', updateBreakpoints);
    desktopQuery.addEventListener('change', updateBreakpoints);

    updateBreakpoints();

    return () => {
      mobileQuery.removeEventListener('change', updateBreakpoints);
      tabletQuery.removeEventListener('change', updateBreakpoints);
      desktopQuery.removeEventListener('change', updateBreakpoints);
    };
  }, []);

  return { isMobile, isTablet, isDesktop };
};
